import { getRecaptchaToken } from './recaptcha';

export function initCommentForm() {
  const form = document.querySelector('#form-comment');
  const messageInput = document.querySelector('#form-message');
  const commentsArea = document.querySelector('#comments-area');
  const loader = document.querySelector('.form-btn-loader');
  const submitBtn = form?.querySelector('button.pbmit-btn');
  const submitText = submitBtn?.querySelector('span');

  if (!form || !messageInput || !commentsArea) return;

  /* -------------------------------
   Enter = submit (sans Shift)
  --------------------------------*/
  messageInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      form.requestSubmit();
    }
  });

  /* -------------------------------
   Submit
  --------------------------------*/
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    // Validation HTML5
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    /* ---------- UI loading ---------- */
    loader?.classList.remove('d-none');
    submitText?.classList.add('d-none');
    submitBtn?.setAttribute('disabled', 'disabled');
    messageInput.setAttribute('disabled', 'disabled');

    /* ---------- Build history ---------- */
    const history = Array.from(
      commentsArea.querySelectorAll('.pbmit-comment-content')
    ).map((el) => ({
      role: el.classList.contains('ai') ? 'assistant' : 'user',
      content: el.querySelector('.content')?.innerHTML ?? '',
    }));

    const message = messageInput.value;

    history.push({ role: 'user', content: message });

    /* ---------- reCAPTCHA token ---------- */
    const token = await getRecaptchaToken('blog_comment');
    const tokenField = form.querySelector('.g-recaptcha-response');
    if (tokenField) tokenField.value = token;

    /* ---------- Serialize form ---------- */
    const data = Object.fromEntries(new FormData(form).entries());
    data.messages = history;

    /* ---------- Append user message ---------- */
    const userTemplate = document.querySelector('#user-question');
    if (userTemplate) {
      const userBloc = userTemplate.cloneNode(true);
      userBloc.removeAttribute('id');
      userBloc.classList.remove('d-none');
      userBloc.querySelector('.content').innerHTML = message;
      commentsArea.appendChild(userBloc);
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            ?.getAttribute('content'),
        },
        body: JSON.stringify(data),
      });

      const json = await response.json();

      /* ---------- Append AI response ---------- */
      const aiTemplate = document.querySelector('#ai-response');
      if (aiTemplate) {
        const aiBloc = aiTemplate.cloneNode(true);
        aiBloc.removeAttribute('id');
        aiBloc.classList.remove('d-none');
        aiBloc.querySelector('.content').innerHTML = json.answer ?? '';
        commentsArea.appendChild(aiBloc);
      }

      messageInput.value = '';
    } catch (err) {
      console.error(err);
    } finally {
      /* ---------- UI reset ---------- */
      loader?.classList.add('d-none');
      submitText?.classList.remove('d-none');
      submitBtn?.removeAttribute('disabled');
      messageInput.removeAttribute('disabled');
    }
  });
}